import React, { useState, useEffect } from "react";
import { useEmployeeAuthContext } from "./useEmployeeAuthContext";
import { useNavigate } from "react-router-dom";

export const EmployeeLogin = () => {

    const [phone, setPhone] = useState("");
    const [pin, setPin] = useState("");

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { employee, login } = useEmployeeAuthContext();

    const navigate = useNavigate();


    // ============================================================
    // CHECK EXISTING LOGIN
    // ============================================================

    useEffect(() => {

        if (employee) {

            navigate("/employee/dashboard", {
                replace: true
            });

        }

    }, [employee, navigate]);


    // ============================================================
    // HANDLE LOGIN
    // ============================================================

    const handleSubmit = async (e) => {

        e.preventDefault();

        setError("");
        setIsLoading(true);

        try {

            await login(phone, pin);

            navigate("/employee/dashboard");

        } catch (error) {

            setError(error.message);

        } finally {

            setIsLoading(false);

        }

    };


    // ============================================================
    // PHONE INPUT
    // ============================================================

    const handlePhoneChange = (e) => {

        const value = e.target.value;

        if (/^\d*$/.test(value)) {

            setPhone(value);

        }

    };


    // ============================================================
    // PIN INPUT
    // ============================================================

    const handlePinChange = (e) => {

        const value = e.target.value;

        if (/^\d{0,4}$/.test(value)) {

            setPin(value);

        }

    };


    return (

        <div className="h-[100dvh] overflow-hidden bg-[#faf8f6] font-sans">

            {/* ====================================================
                MOBILE LOGIN CONTAINER
            ==================================================== */}

                <div className="mx-auto flex h-full w-full max-w-[390px] flex-col overflow-hidden px-7">


                {/* ====================================================
                    TOP SPACING / BRAND
                ==================================================== */}

                <div className="pt-[118px]">

                    <div className="flex items-center gap-2.5">

                        {/* SIMPLE LOGO MARK */}

                        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#7a3ea3] text-sm font-bold text-white shadow-sm">

                            S

                        </div>


                        <div className="text-[19px] font-bold tracking-[-0.02em] text-[#1f1b19]">

                            SpaClock

                        </div>

                    </div>


                    {/* ====================================================
                        PAGE TITLE
                    ==================================================== */}

                    <h1 className="mt-14 text-[34px] font-semibold leading-[1.1] tracking-[-0.025em] text-[#1f1b19]">

                        Staff Sign In

                    </h1>

                </div>


                {/* ====================================================
                    ERROR MESSAGE
                ==================================================== */}

                {error && (

                    <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">

                        {error}

                    </div>

                )}


                {/* ====================================================
                    LOGIN FORM
                ==================================================== */}

                <form
                    onSubmit={handleSubmit}
                    className="mt-10 flex flex-col gap-3.5"
                >


                    {/* ====================================================
                        PHONE NUMBER
                    ==================================================== */}

                    <label className="flex flex-col gap-2 text-[14px] font-medium text-[#5c5651]">

                        Phone number

                        <input
                            id="phone"
                            type="tel"
                            value={phone}
                            onChange={handlePhoneChange}
                            placeholder="(555) 000-0000"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete="tel"
                            required
                            className="
                                h-[60px]
                                w-full
                                rounded-2xl
                                border-[1.5px]
                                border-[#dcd6d1]
                                bg-white
                                px-[18px]
                                text-[18px]
                                text-[#1f1b19]
                                outline-none
                                transition
                                placeholder:text-[#b3aca7]
                                focus:border-[#7a3ea3]
                                focus:ring-[3px]
                                focus:ring-[#7a3ea3]/15
                            "
                        />

                    </label>


                    {/* ====================================================
                        PIN
                    ==================================================== */}

                    <label className="flex flex-col gap-2 text-[14px] font-medium text-[#5c5651]">

                        PIN

                        <input
                            id="pin"
                            type="password"
                            value={pin}
                            onChange={handlePinChange}
                            placeholder="••••"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete="off"
                            maxLength={4}
                            required
                            className="
                                h-[60px]
                                w-full
                                rounded-2xl
                                border-[1.5px]
                                border-[#dcd6d1]
                                bg-white
                                px-[18px]
                                text-[22px]
                                tracking-[0.3em]
                                text-[#1f1b19]
                                outline-none
                                transition
                                placeholder:text-[#b3aca7]
                                focus:border-[#7a3ea3]
                                focus:ring-[3px]
                                focus:ring-[#7a3ea3]/15
                            "
                        />

                    </label>


                    {/* ====================================================
                        LOGIN BUTTON
                    ==================================================== */}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="
                            mt-[14px]
                            h-[60px]
                            w-full
                            rounded-[18px]
                            border-none
                            bg-[#7a3ea3]
                            text-[18px]
                            font-semibold
                            text-white
                            shadow-sm
                            transition-all
                            hover:bg-[#6a3590]
                            active:scale-[0.985]
                            disabled:cursor-not-allowed
                            disabled:opacity-60
                        "
                    >

                        {isLoading
                            ? "Signing In..."
                            : "Sign In"}

                    </button>


                </form>


            </div>

        </div>

    );

};